import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
`

export const TextCenter = styled.div`
  text-align: center;
  width: 80%;
  margin: 0 auto;
`
